export default "__VITE_ASSET__DEViWGIS__"